import { supabase } from '@/lib/supabase'

export type RoleSignalsPolicy = {
  role: string
  signals_enabled: boolean
}

export type PlanSignalsPolicy = {
  plan_id: string
  signals_enabled: boolean
}

export async function fetchRoleSignalsPolicies(): Promise<RoleSignalsPolicy[]> {
  const { data, error } = await supabase
    .from('role_signals_policies')
    .select('role,signals_enabled')
    .order('role', { ascending: true })

  if (error) throw error
  return (data || []) as RoleSignalsPolicy[]
}

export async function upsertRoleSignalsPolicy(role: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('role_signals_policies')
    .upsert({ role, signals_enabled: enabled }, { onConflict: 'role' })

  if (error) throw error
}

export async function fetchPlanSignalsPolicies(): Promise<PlanSignalsPolicy[]> {
  const { data, error } = await supabase
    .from('plan_signals_policies')
    .select('plan_id,signals_enabled')
    .order('plan_id', { ascending: true })

  if (error) throw error
  return (data || []) as PlanSignalsPolicy[]
}

export async function upsertPlanSignalsPolicy(planId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('plan_signals_policies')
    .upsert({ plan_id: planId, signals_enabled: enabled }, { onConflict: 'plan_id' })

  if (error) throw error
}

